import { useState } from 'react';

import type { ConfirmOptions } from './ConfirmRoot';

export const useConfirmationModal = () => {
  const [confirm, setConfirm] = useState({
    isVisible: false,
    componentName: null,
    props: {},
  });

  const showConfirm = (
    componentName: ConfirmOptions['componentName'] = null,
    props: ConfirmOptions['props'] = {},
  ) =>
    setConfirm({
      ...confirm,
      isVisible: true,
      componentName,
      props,
    });

  const cancelConfirm = () =>
    setConfirm({
      isVisible: false,
      componentName: null,
      props: {},
    });

  return {
    showConfirm,
    cancelConfirm,
    confirm,
  };
};
